import { z } from "zod";

import { VersionStringSchema } from "../manifest/schemas";
import type { LoadingModuleRef, WireErrorViewRef, WireModuleRef } from "./types";

/**
 * Zod schema for a module ref on the wire with props (e.g. the flow
 * `errorView`). `props` must be a plain JSON-serialisable object; functions
 * are rejected because they can't survive serialisation. Server-only
 * `dataParams` are not part of the wire shape and are stripped.
 */
export const ModuleRefSchema = z.object({
  _tag: z.literal("ModuleRef"),
  moduleId: z.string().min(1),
  minVersion: VersionStringSchema,
  props: z.record(z.string(), z.unknown()),
}) satisfies z.ZodType<WireErrorViewRef>;

/**
 * Zod schema for {@link WireModuleRef} — bare module identity. No `props`
 * (may be function-form at the source) and no `dataParams` (server-only).
 */
export const WireModuleRefSchema = z.object({
  _tag: z.literal("ModuleRef"),
  moduleId: z.string().min(1),
  minVersion: VersionStringSchema,
}) satisfies z.ZodType<WireModuleRef>;

/**
 * Zod schema for {@link LoadingModuleRef} — a loading module reference with
 * static props.
 */
export const LoadingModuleRefSchema = z.object({
  _tag: z.literal("LoadingModuleRef"),
  moduleId: z.string().min(1),
  minVersion: VersionStringSchema,
  props: z.record(z.string(), z.unknown()),
}) satisfies z.ZodType<LoadingModuleRef>;
